import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { ReactElement } from 'react';
import { CompanyLogoAndName } from '../../../grid-renderers/CompanyCellRenderer';

import { cardStyles } from '../../../../theme/component-styles';
import { MostRecentChartData } from '../../../../pages/PortfolioOverview/hooks/useMostRecentRounds';
import { FMT } from '../../../../util/formatter-service';
import { RoundNameRenderer } from '../../../AgTable/cell-renderers/RoundRenderer';
import { IMostRecentDataChartProps } from './MostRecentDataChart';

export const PortfolioChartRow = styled('li')`
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: subgrid;

  @supports not (grid-template-columns: subgrid) {
    grid-auto-flow: column;
    grid-auto-columns: minmax(0, 1fr);
  }
`;

export function MostRecentRow({
  columnFields,
  company: { name, logoUrl },
  dealLead,
  round,
  date,
  formattedValue,
  formattedValue2,
}: MostRecentChartData & Pick<IMostRecentDataChartProps, 'columnFields'>): ReactElement {
  return (
    <PortfolioChartRow style={{ ...cardStyles, padding: '0.25rem 0.5rem', minWidth: '1rem' }}>
      <CompanyLogoAndName name={name} logoUrl={logoUrl ?? ''} />
      {dealLead != null || columnFields.includes('dealLead') ? (
        <Typography variant={'body2'} noWrap sx={{ marginBlock: 'auto' }} title={dealLead}>
          {dealLead}
        </Typography>
      ) : null}
      {round ? (
        <RoundNameRenderer
          name={round}
          truncate
          style={{
            minWidth: '7rem',
            maxWidth: '7rem',
            fontSize: '0.8rem',
            margin: 'auto',
            color: 'text.primary',
            paddingInline: '0.2rem',
          }}
        />
      ) : columnFields.includes('round') ? (
        <div />
      ) : null}

      <Typography variant={'monotype'} noWrap sx={{ marginBlock: 'auto' }}>
        {FMT.format('monthYear', date)}
      </Typography>
      <Typography
        variant={'monotype'}
        noWrap
        sx={{ display: 'grid', alignItems: 'center', justifyContent: 'end' }}
      >
        {formattedValue}
      </Typography>
      {(formattedValue2 != null || columnFields.includes('formattedValue2')) && (
        <Typography
          variant={'monotype'}
          noWrap
          sx={{ display: 'grid', alignItems: 'center', justifyContent: 'end' }}
        >
          {formattedValue2}
        </Typography>
      )}
    </PortfolioChartRow>
  );
}
